import axios from 'axios';
import { formatTimeValue, cleanTimeValue } from '@/_helpers/utils.js';
import { merge } from 'lodash';
import Vue from 'vue';

export default {
  namespaced: true,

  state() {
    return {
      list: []
    };
  },

  mutations: {
    clear: state => {
      state.list = [];
    },

    add_answer: (state, data) => {
      // obj, id
      let item = state.list.filter(i => i._id === data.id)[0];
      item.answers.push(new Answer(data.obj));
    },

    prepare_to_save(state) {
      if (state.list) {
        state.list.forEach(i => {
          // if(i.answers && i.type === 'value') {
          //   i.answers = JSON.parse(JSON.stringify(i.value));
          // }
          i.time_limit = i._time_limit ? cleanTimeValue(i._time_limit) : i._time_limit || 120;
        });
      }
    },

    // v, id
    set_time_limit_enabled(state, data) {
      let item = state.list.filter(i => i._id === data.id)[0];
      item.time_limit_enabled = data.v;
    },

    // v, id
    set_time_limit(state, data) {
      let item = state.list.filter(i => i._id === data.id)[0];
      item._time_limit = data.val;
    },

    // v, id
    set_has_valid_answer(state, data) {
      let item = state.list.filter(i => i._id === data.id)[0];
      item.has_valid_answer = data.v;
      item.value[0].valid = data.v;
    },

    // v, id
    set_correct_answer(state, data) {
      let item = state.list.filter(i => i._id === data.id)[0];
      item.correct_answer = data.v;
    },

    // v, id
    set_separate_page(state, data) {
      let item = state.list.filter(i => i._id === data.id)[0];
      if (item.media) {
        item.media.is_separate_page = data.v;
      }
    },

    // v, id
    set_media_id(state, data) {
      let item = state.list.filter(i => i._id === data.id)[0];
      if (item.media) {
        item.media.vacancy_module_test_question_id = data.v;
      }
    },

    // v, id
    set_video_title(state, data) {
      let item = state.list.filter(i => i._id === data.id)[0];

      if (item.media) {
        item.media.title = data.v;
      }
    },

    // v, answer_id, question_id
    set_value_body(state, data) {
      let item = state.list.filter(i => i._id === data.question_id)[0];
      item.value[0].body = data.v;
      item.value[0].is_valid = !!data.v;
    },

    // v, answer_id, question_id
    set_answer_body(state, data) {
      let item = state.list.filter(i => i._id === data.question_id)[0];
      let answer = item.answers.filter(i => i._id === data.answer_id)[0];
      answer.body = data.v;
    },

    // v, answer_id, question_id
    set_media(state, data) {
      let item = state.list.filter(i => i._id === data.question_id)[0];
      item.media = data.v;
    },

    // setGraphJson(state, { questionId, jsonData }) {
    //   const questionIndex = state.list.findIndex(x => x._id === questionId);

    //   if (questionIndex >= 0) {
    //     state.list[questionIndex].chart_config = jsonData;
    //   }
    // },

    // v, answer_id, question_id
    set_answer_is_valid(state, data) {
      let item = state.list.filter(i => i._id === data.question_id)[0];

      if (data.v !== undefined) {
        let answer = item.answers.filter(i => i._id === data.answer_id)[0];

        if (item.type === 'multichoice') {
          /*
          let vanswers = item.answers.filter(i => i.is_valid);
          if(vanswers.length === 1 && data.v) {
            answer.is_valid = data.v;
          } else if(vanswers.length === 1 && data.v && vanswers[0].id !== data.answer_id) {
            answer.is_valid = data.v;
          } else if (vanswers.length > 1) {
            answer.is_valid = data.v;
          }
          */
          answer.valid = data.v;
        } else {
          item.answers.forEach(i => {
            if (i._id === data.answer_id) {
              i.valid = true;
            } else {
              i.valid = false;
            }
          });
        }
      } else {
        if (item.type === 'choice') {
          let setted = false;
          item.answers.forEach(i => {
            if (i.valid && !setted) {
              i.valid = true;
              setted = true;
            } else {
              i.valid = false;
            }
          });
        }
      }
    },

    del_item(state, id) {
      let pos = state.list.map(i => i._id).indexOf(id);
      state.list.splice(pos, 1);
    },

    del_answer(state, data) {
      // id, question_id
      let item = state.list.filter(i => i._id === data.question_id)[0];
      let pos = item.answers.map(i => i._id).indexOf(data.id);
      item.answers.splice(pos, 1);
    },

    add_item: (state, obj) => {
      state.list.push(new Question(obj));
    },

    // id, body, type, error
    update_item: (state, data) => {
      let item = state.list.filter(i => i._id === data.id)[0];
      item.body = data.body !== undefined ? data.body : item.body;
      if (data.type === 'choice') {
        let valid_answers = item.answers.filter(i => i.valid === true);
        if (valid_answers.length === 0) {
          item.answers[0].valid = true;
        }
      }
      item.type = data.type ? data.type : item.type;
      item._error = data.error !== undefined ? data.error : item._error;
    },

    // sort_up(state, id) {
    //   let pos = state.list.map(i => i._id).indexOf(id);
    //   let next = state.list[pos + 1];
    //   let cur = state.list[pos];

    //   if (next !== undefined) {
    //     let sort_order = cur.sort_order;
    //     cur.sort_order = next.sort_order;
    //     next.sort_order = sort_order;
    //     state.list.splice(pos, 2, next, cur);
    //   }
    // },

    // sort_down(state, id) {
    //   let pos = state.list.map(i => i._id).indexOf(id);
    //   let prev = state.list[pos - 1];
    //   let cur = state.list[pos];

    //   if (prev !== undefined) {
    //     let sort_order = cur.sort_order;
    //     cur.sort_order = prev.sort_order;
    //     prev.sort_order = sort_order;
    //     state.list.splice(pos - 1, 2, cur, prev);
    //   }
    // },

    sort_change(state, questions) {
      const newOrderedList = [];
      let currentOrder = 0;

      questions.forEach(item => {
        const newItem = Object.assign({}, item);
        currentOrder += 1000;
        newItem.sort_order = currentOrder;

        newOrderedList.push(newItem);
      });

      state.list = newOrderedList;
      // let new_ordered_list = [];

      // questions.forEach((item, index) => {
      //   new_ordered_list.push(Object.assign({}, item, {
      //     sort_order: state.list[index].sort_order
      //   }))
      // });

      // state.list.splice(0, state.list.length, ...new_ordered_list);
    },

    MAKE_LIST_SORT(state) {
      state.list.sort((a, b) => (a.sort_order > b.sort_order ? 1 : -1));
    },

    reset_ids(state, list) {
      let new_q = state.list.filter(i => i._new === true);
      new_q.forEach(i => {
        i._id = list.filter(e => Number(e.local_id) === Number(i.local_id))[0]._id;
      });
    },

    update_correct_answer(state) {
      state.list.forEach(item => {
        if (item.type === 'choice' || item.type === 'multichoice') {
          if (item.correct_answer) {
            item.has_valid_answer = false;
          } else {
            item.has_valid_answer = true;
          }
        }
      });
    },

    update_valid(state) {
      state.list.forEach(item => {
        if (item.type === 'value' && item.has_valid_answer) {
          item.answers.forEach(answer => {
            answer.valid = true;
          });
        }
      });
    },

    changeAnswerProperty(state, { questionId, answerId, property, value }) {
      const questionIndex = state.list.findIndex(x => x.id === questionId);

      if (questionIndex >= 0) {
        const answerIndex = state.list[questionIndex].answers.findIndex(x => x.id === answerId);

        if (answerIndex >= 0) {
          state.list[questionIndex].answers[answerIndex][property] = value;
        }
      }
    },

    // Graphs
    toggleGraphEnabled(state, questionId) {
      const questionIndex = state.list.findIndex(x => x.id === questionId);

      if (questionIndex >= 0) {
        state.list[questionIndex].is_graph_enabled = !state.list[questionIndex].is_graph_enabled;
      }
    },

    // Variables
    toggleVariablesEnabled(state, questionId) {
      const questionIndex = state.list.findIndex(x => x.id === questionId);

      if (questionIndex >= 0) {
        state.list[questionIndex].is_variables_enabled = !state.list[questionIndex].is_variables_enabled;
      }
    },

    addVariable(state, questionIndex) {
      let newName = '';
      const variableTemplates = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
      // const questionIndex = state.list.findIndex(x => x.id === questionId);

      variableTemplates.every(element => {
        const findVariable = state.list[questionIndex].variables.find(x => x.name === element);

        if (findVariable === undefined) {
          newName = element;

          return false; // stops every
        }

        return true;
      });

      const newVariable = {
        name: newName,
        formula: '',
        isFormula: false, // потому что поле formula пустое
        min: 1,
        max: 10,
        step: 0,
        type: 1
      };

      if (questionIndex >= 0) {
        state.list[questionIndex].variables.push(newVariable);
      }
    },

    removeVariable(state, { questionIndex, variableName }) {
      // const questionIndex = state.list.findIndex(x => x.id === questionId);

      if (questionIndex >= 0) {
        const variableIndex = state.list[questionIndex].variables.findIndex(x => x.name === variableName);
        state.list[questionIndex].variables.splice(variableIndex, 1);
      }
    },

    updateVariable(state, { questionId, variableName, property, newValue }) {
      const questionIndex = state.list.findIndex(x => x.id === questionId);

      if (questionIndex >= 0) {
        const variableIndex = state.list[questionIndex].variables.findIndex(x => x.name === variableName);

        if (variableIndex >= 0) {
          if (property === 'type') {
            if (newValue) {
              state.list[questionIndex].variables[variableIndex].type = 1;
            } else {
              state.list[questionIndex].variables[variableIndex].type = 2;
            }
          } else {
            if (property === 'min' || property === 'max' || property === 'step') {
              state.list[questionIndex].variables[variableIndex][property] = Number(newValue);
            } else {
              state.list[questionIndex].variables[variableIndex][property] = newValue;
            }
          }
        }
      }
    },

    // CHART CONFIGS
    ADD_EMPTY_CHARTCONFIG: (state, questionIndex) => {
      const defaultChartConfig = {
        version: 1,
        type: 'line',
        labels: [],
        options: {
          chart: {
            stacked: false
          }
        },
        series: [{ name: '', data: [] }],
        variables: []
      };

      state.list[questionIndex].chart_config.push(defaultChartConfig);
    },

    REMOVE_CHARTCONFIG: (state, { questionIndex, indexChart }) => {
      state.list[questionIndex].chart_config.splice(indexChart, 1);
    },

    CHANGE_GRAPH_TYPE: (state, { questionIndex, indexChart, newType }) => {
      const config = { ...state.list[questionIndex].chart_config[indexChart] };
      config.type = newType;

      if (newType === 'pie' || newType === 'donut') {
        config.series = [];
      } else {
        config.series = [{ name: '', data: [] }];
      }

      state.list[questionIndex].chart_config.splice(indexChart, 1, config);
    },

    CHANGE_CHARTCONFIG_OPTION: (state, { indexQuestion, indexChart, optionName, optionValue }) => {
      if (state.list[indexQuestion].chart_config[indexChart].options.chart === undefined) {
        state.list[indexQuestion].chart_config[indexChart].options.chart = {};
      }

      state.list[indexQuestion].chart_config[indexChart].options.chart[optionName] = optionValue;
    },

    ADD_GRAPH: (state, { indexQuestion, indexChart }) => {
      state.list[indexQuestion].chart_config[indexChart].series.push({ name: '', data: [] });
    },

    UPDATE_GRAPH_NAME(state, { indexQuestion, indexChart, indexSeries, newName }) {
      state.list[indexQuestion].chart_config[indexChart].series[indexSeries].name = newName;
    },

    REMOVE_GRAPH(state, { indexQuestion, indexChart, indexSeries }) {
      state.list[indexQuestion].chart_config[indexChart].series.splice(indexSeries, 1);
    },

    CHANGE_GRAPH_TYPE_COMBO: (state, { indexQuestion, indexChart, indexSeries, newType }) => {
      state.list[indexQuestion].chart_config[indexChart].series[indexSeries].type = newType;
    },

    ADD_GRAPH_DATA: (state, { indexQuestion, indexChart, indexSeries, newValue }) => {
      state.list[indexQuestion].chart_config[indexChart].series[indexSeries].data.push(Number(newValue));
    },

    ADD_GRAPH_DATA_PIE: (state, { indexQuestion, indexChart, newValue }) => {
      state.list[indexQuestion].chart_config[indexChart].series.push(Number(newValue));
    },

    UPDATE_GRAPH_DATA(state, { indexQuestion, indexChart, indexSeries, indexData, newValue }) {
      state.list[indexQuestion].chart_config[indexChart].series[indexSeries].data.splice(
        indexData,
        1,
        Number(newValue)
      );
    },

    UPDATE_GRAPH_DATA_PIE(state, { indexQuestion, indexChart, indexData, newValue }) {
      state.list[indexQuestion].chart_config[indexChart].series.splice(indexData, 1, Number(newValue));
    },

    REMOVE_GRAPH_DATA(state, { indexQuestion, indexChart, indexSeries, indexData }) {
      state.list[indexQuestion].chart_config[indexChart].series[indexSeries].data.splice(indexData, 1);

      // remove last label if length of data is less than length of the longest series
      let maxLengthOfExistedData = 0;
      const series = state.list[indexQuestion].chart_config[indexChart].series;
      const labels = state.list[indexQuestion].chart_config[indexChart].labels;

      for (const key in series) {
        if (series[key].data !== undefined && series[key].data.length > maxLengthOfExistedData) {
          maxLengthOfExistedData = series[key].data.length;
        }
      }

      if (maxLengthOfExistedData !== 0 && labels.length > maxLengthOfExistedData) {
        state.list[indexQuestion].chart_config[indexChart].labels.length =
          state.list[indexQuestion].chart_config[indexChart].labels.length -
          (state.list[indexQuestion].chart_config[indexChart].labels.length - maxLengthOfExistedData);
      }

      if (maxLengthOfExistedData === 0) {
        state.list[indexQuestion].chart_config[indexChart].labels = [];
      }
    },

    REMOVE_GRAPH_DATA_PIE(state, { indexQuestion, indexChart, indexData }) {
      state.list[indexQuestion].chart_config[indexChart].series.splice(indexData, 1);

      // remove last label if length of data is less than length of the longest series
      let maxLengthOfExistedData = 0;
      const series = state.list[indexQuestion].chart_config[indexChart].series;
      const labels = state.list[indexQuestion].chart_config[indexChart].labels;

      for (const key in series) {
        if (series[key].data !== undefined && series[key].data.length > maxLengthOfExistedData) {
          maxLengthOfExistedData = series[key].data.length;
        }
      }

      if (maxLengthOfExistedData !== 0 && labels.length > maxLengthOfExistedData) {
        state.list[indexQuestion].chart_config[indexChart].labels.length =
          state.list[indexQuestion].chart_config[indexChart].labels.length -
          (state.list[indexQuestion].chart_config[indexChart].labels.length - maxLengthOfExistedData);
      }

      if (maxLengthOfExistedData === 0) {
        state.list[indexQuestion].chart_config[indexChart].labels = [];
      }
    },

    ADD_GRAPH_LABEL(state, { indexQuestion, indexChart, newLabel }) {
      const labelsLength = state.list[indexQuestion].chart_config[indexChart].labels.length;
      Vue.set(state.list[indexQuestion].chart_config[indexChart].labels, labelsLength, newLabel); // mutable for change getter then
      // state.list[indexQuestion].chart_config[indexChart].labels.push(newLabel);
      // state.list[indexQuestion].chart_config[indexChart].options.xaxis.categories.push(newLabel);
    },

    UPDATE_GRAPH_LABEL(state, { indexQuestion, indexChart, indexLabel, value }) {
      Vue.set(state.list[indexQuestion].chart_config[indexChart].labels, indexLabel, value); // mutable for change getter then
      // state.list[indexQuestion].chart_config[indexChart].labels[indexLabel] = value;
      // state.list[indexQuestion].chart_config[indexChart].options.xaxis.categories[indexLabel] = value;
    },

    REMOVE_GRAPH_LABEL(state, { indexQuestion, indexChart, indexLabel }) {
      state.list[indexQuestion].chart_config[indexChart].labels.splice(indexLabel, 1); // splice mutable
      // state.list[indexQuestion].chart_config[indexChart].options.xaxis.categories.splice(indexLabel, 1);
    },

    ADD_GRAPH_VARIABLE(state, { indexQuestion, indexChart, indexSeries, indexData, variableName }) {
      const currentVariables = state.list[indexQuestion].chart_config[indexChart].variables;
      const variableIndex = currentVariables.findIndex(x => x.indexSeries === indexSeries && x.indexData === indexData);

      if (variableIndex >= 0) {
        state.list[indexQuestion].chart_config[indexChart].variables[variableIndex].variableName = variableName;
      } else {
        const newData = {
          indexSeries,
          indexData,
          variableName
        };

        state.list[indexQuestion].chart_config[indexChart].variables.push(newData);
      }
    },

    REMOVE_GRAPH_VARIABLE(state, { indexQuestion, indexChart, indexSeries, indexData }) {
      const currentVariables = state.list[indexQuestion].chart_config[indexChart].variables;
      const variableIndex = currentVariables.findIndex(x => x.indexSeries === indexSeries && x.indexData === indexData);

      if (variableIndex >= 0) {
        state.list[indexQuestion].chart_config[indexChart].variables.splice(variableIndex, 1);
      }
    },

    RESET_VARIABLES(state) {
      for (let q = 0; q < state.list.length; q++) {
        const question = state.list[q];

        for (let w = 0; w < question.chart_config.length; w++) {
          const config = question.chart_config[w];

          config.variables = [];
        }
      }
    },

    UPDATE_ROUNDING_PRECISION(state, { questionId, newPrecision }) {
      const question = state.list.find(x => x.id === questionId);
      let newNumber = Number(newPrecision);

      if (Number(newNumber) > 12) {
        newNumber = 12;
      }
      if (Number(newNumber) < 0) {
        newNumber = 0;
      }

      if (question !== undefined) {
        question.rounding_precision = newNumber;
      }
    }
  },

  actions: {
    set_list({ commit, getters }, list) {
      commit('clear');

      list.forEach(obj => {
        if (obj && obj.chart_config && obj.chart_config.length > 0) {
          for (let i = 0; i < obj.chart_config.length; i++) {
            const config = obj.chart_config[i];
            const regex = /{{[a-z]}}/;

            if (config.type === 'pie' || config.type === 'donut') {
              for (let u = 0; u < config.series.length; u++) {
                // value - каждое из значений в графике, может быть числом и может быть переменной
                const value = config.series[u];

                if (regex.test(value)) {
                  // для всех переменных убираем {{ и }}, получаем имя переменной
                  const variableName = value.replace('{{', '').replace('}}', '');
                  // если находим переменную (она находится по наличию {{ и }}), то добавляем переменную в state.variables
                  if (obj.chart_config[i].variables === undefined) {
                    obj.chart_config[i].variables = [];
                  }
                  // находит объект переменной со всеми свойствами для генерации
                  const variable = obj.variables.find(x => x.name == variableName);

                  if (variable !== undefined) {
                    obj.chart_config[i].series[u] = getters.generateVariableValue(variable);
                  }
                }
              }
            } else {
              for (let u = 0; u < config.series.length; u++) {
                const arrayOfValues = config.series[u].data;

                for (let y = 0; y < arrayOfValues.length; y++) {
                  // value - каждое из значений в графике, может быть числом и может быть переменной
                  const value = arrayOfValues[y];

                  if (regex.test(value)) {
                    // для всех переменных убираем {{ и }}, получаем имя переменной
                    const variableName = value.replace('{{', '').replace('}}', '');
                    // если находим переменную (она находится по наличию {{ и }}), то добавляем переменную в state.variables
                    if (obj.chart_config[i].variables === undefined) {
                      obj.chart_config[i].variables = [];
                    }

                    // находит объект переменной со всеми свойствами для генерации значения переменной
                    const variable = obj.variables.find(x => x.name == variableName);

                    if (variable !== undefined) {
                      obj.chart_config[i].series[u].data[y] = getters.generateVariableValue(variable);
                    }
                  }
                }
              }
            }
          }
        }

        // add answers
        if (obj && obj._embedded && obj._embedded.answers && obj._embedded.answers.length === 0) {
          obj._embedded.answers.push(new Answer({ _new: true }));
        }

        commit('add_item', obj);
      });

      commit('MAKE_LIST_SORT');
    },

    save(context, test_id) {
      let new_q = context.getters['list'].filter(i => i._new === true);
      let q = context.getters['list'].filter(i => i._new !== true);

      return Promise.all([
        axios.post(`/1.0/tests/${test_id}/questions`, { questions: new_q }),
        axios.put(`/1.0/tests/${test_id}/questions`, { questions: q })
      ]).then(r => {
        context.commit('reset_ids', r[0].data.data);
      });
    },

    save_answers(context, data) {
      // test_id, question_id
      let question = context.getters['list'].filter(i => i._id === data.question_id)[0];
      let new_a = question.answers.filter(i => i._new === true && !i._deleted);
      let a = question.answers.filter(i => i._new !== true && !i._deleted);
      return Promise.all([
        axios.post(`/1.0/tests/${data.test_id}/questions/${data.question_id}/answers`, { answers: new_a }),
        axios.put(`/1.0/tests/${data.test_id}/questions/${data.question_id}/answers`, { answers: a })
      ]).then(() => {
        // context.commit('reset_ids', r[0].data.data)
      });
    }
  },

  getters: {
    list: state => state.list.filter(i => !i._deleted),

    questions_has_answers(state) {
      let result = true;
      state.list.forEach(i => {
        if (i.type === 'file') {
          result = true;
        } else if (i.type === 'value') {
          if (i.has_valid_answer && i.answers.filter(a => a.body === '' || a.body === null).length > 0) {
            result = false;
          }
        } else {
          if (i.answers.filter(a => a.body === '' || a.body === null).length > 0) {
            result = false;
          }
        }
      });

      return result;
    },

    generateVariableValue: () => variable => {
      const min = Number(variable.min);
      const max = Number(variable.max);
      const step = Number(variable.step);
      const randomWithStep = Number(min + step * Math.round(Math.random() * Math.floor((max - min) / step)));

      if (variable.type == 1) {
        // return Number(Math.floor(Math.random() * (max - min + 1)) + min); --old
        return Number(randomWithStep.toFixed(0));
      } else {
        // return Number(Math.random() * (max - min + 1) + min).toFixed(4); --old
        return Number(randomWithStep.toFixed(4));
      }
    },

    getQuestionIndex: state => questionId => {
      return state.list.findIndex(x => x.id === questionId);
    },

    getRoundingPrecision: state => questionId => {
      const question = state.list.find(x => x.id === questionId);

      if (question !== undefined) {
        return question.rounding_precision;
      }

      return 4;
    },

    getApexOptions:
      state => ({ questionId, indexChart }) => {
        const question = state.list.find(x => x.id == questionId);

        if (question.chart_config !== null && question.chart_config[indexChart] !== undefined) {
          // split long labels by some words and convert them to arrays
          const formattedLabels = question.chart_config[indexChart].labels.map(x => {
            if (x.length > 25) {
              const arrayOfWords = x.split(' ');
              let newArray = [];

              // 3 – there is for words to wrap on the next line
              for (let i = 3; i < arrayOfWords.length; i++) {
                if (i % 3 == 0) {
                  newArray.push(`${arrayOfWords[i - 2]} ${arrayOfWords[i - 1]} ${arrayOfWords[i]}`);
                }
              }

              return newArray;
            } else {
              return x;
            }
          });

          let formattedSeries = [];

          if (question.chart_config[indexChart].type === 'donut' || question.chart_config[indexChart].type === 'pie') {
            formattedSeries = question.chart_config[indexChart].series.map(x => {
              return Number(x);
            });
          } else {
            for (let index = 0; index < question.chart_config[indexChart].series.length; index++) {
              const elementData = question.chart_config[indexChart].series[index].data.map(x => {
                return Number(x);
              });

              formattedSeries.push({ name: question.chart_config[indexChart].series[index].name, data: elementData });
            }
          }

          const labelsOverwriteForSpread = {
            labels: formattedLabels,
            series: formattedSeries
            // chart: { labels: formattedLabels },
            // xaxis: { categories: formattedLabels }
          };

          const defaultOptions = {
            // labels: question.chart_config[indexChart].labels,
            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                if (
                  question.chart_config[indexChart].type === 'pie' ||
                  question.chart_config[indexChart].type === 'donut'
                ) {
                  const name = opts.w.globals.labels[opts.seriesIndex];

                  if (opts.w.config.chart.stackType === 'normal') {
                    const value = opts.w.globals.series[opts.seriesIndex];

                    return [name, value];
                  } else {
                    return [name, val.toFixed(1) + '%'];
                  }
                }

                if (
                  question.chart_config[indexChart].options.chart.stackType !== undefined &&
                  question.chart_config[indexChart].options.chart.stackType === '100%'
                ) {
                  return val.toFixed(0) + '%';
                }

                return val;
              }
            },

            legend: {
              onItemClick: { toggleDataSeries: false }
            },

            chart: {
              height: '300px',
              animations: { enabled: false },
              stacked: false,
              stackType: 'normal',
              toolbar: { show: false },
              selection: { enabled: false },
              zoom: { enabled: false },
              stroke: {
                show: true,
                curve: 'smooth',
                lineCap: 'butt',
                width: 2
              }
            }
          };

          const object = merge(defaultOptions, question.chart_config[indexChart].options, labelsOverwriteForSpread);
          // delete object.xaxis;

          // console.log(object);

          return object;
        } else {
          return null;
        }
      },

    currentGraphType: state => ({ questionIndex, indexChart }) => {
      const question = state.list[questionIndex];

      if (question !== undefined) {
        return question.chart_config[indexChart].type;
      }

      return 'line';
    },

    getQuestionVariables: state => indexQuestion => {
      if (
        state.list.length > 0 &&
        state.list[indexQuestion] !== undefined &&
        state.list[indexQuestion].variables !== undefined
      ) {
        return state.list[indexQuestion].variables;
      }

      return [];
    },

    getQuestionConfig: state => (indexQuestion, indexChart) => {
      return state.list[indexQuestion].chart_config[indexChart];
    },

    isDataVariable: state => ({ indexQuestion, indexChart, indexSeries, indexData }) => {
      let variable = false;
      const question = state.list[indexQuestion];
      const chartType = question.chart_config[indexChart].type;

      if (chartType !== undefined && (chartType === 'pie' || chartType === 'donut')) {
        variable = question.chart_config[indexChart].variables.find(x => x.indexData === indexData);
      } else {
        variable = question.chart_config[indexChart].variables.find(
          x => x.indexSeries === indexSeries && x.indexData === indexData
        );
      }

      return variable !== undefined ? variable.variableName : false;
    }
  }
};

class Question {
  constructor(data) {
    let item = data || {};
    if (item.id) {
      this.id = item.id;
    }
    this._id = item.id || Date.now(); // внутренний _id чтобы не перезаписывать id от сервера
    this.local_id = Date.now(); // внутренний локальный id чтобы был уникальный ключ фронта, для идентификации новосозданного вопроса либо уже существуещего проверкой local_id === _id
    this.name = item.name || '';
    this.body = item.body || '';
    this.is_graph_enabled = item.is_graph_enabled || false;
    this.is_variables_enabled = item.is_variables_enabled || false;
    this.chart_config = item.chart_config !== null ? item.chart_config : [];
    // для переменных у которых есть запись в поле formula выставляем isFormula = true (флаг используется для переключателя в настройке переменных в вакансии)
    let variables = [];
    if (item.variables !== undefined) {
      variables = item.variables.map(x => {
        return {
          ...x,
          isFormula: x.formula !== null && x.formula.length > 0
        };
      });
    }
    this.variables = variables || [];
    this.rounding_precision = item.rounding_precision || 4;
    this.media = item.media || null;
    this.type = item.type || 'choice';
    if (this.type !== 'file') {
      this.has_valid_answer =
        item.has_valid_answer !== undefined && item.has_valid_answer !== null ? item.has_valid_answer : false;
    } else {
      this.has_valid_answer = false;
    }

    this.sort_order = item.sort_order;

    this.correct_answer = item.has_valid_answer || !item.body ? false : true;
    this.time_limit_enabled = item.time_limit_enabled || false;
    this.time_limit = item.time_limit || 120;
    this._time_limit = formatTimeValue(this.time_limit, 'hh:mm:ss');
    this.sort_order =
      item.sort_order !== undefined && item.sort_order !== null ? item.sort_order : Number((Date.now() + '').slice(-9));
    this._new = item._new || false;
    this._deleted = false;
    this.value = [new Answer({ _new: true })];
    if (this.type === 'choice') {
      this.answers = [new Answer({ _new: true, valid: true })];
    } else {
      this.answers = [new Answer({ _new: true })];
    }
    this._error = '';

    this.answers = [];

    if (item._embedded && item._embedded.answers && item._embedded.answers.length > 0) {
      item._embedded.answers.forEach(i => {
        this.answers.push(new Answer(i));
      });
    } else {
      this.answers.push(new Answer({ _new: true }));
    }
  }
}

class Answer {
  constructor(data) {
    let item = data || {};
    if (item.id) {
      this.id = item.id;
    }
    this._id = item.id || Date.now();
    this.local_id = Date.now();
    this.is_formula = item.is_formula || false;
    this.body = item.body || '';
    this.sort_order = item.id || 1;
    this.valid = item.valid || false;
    this._new = item._new || false;
    this._deleted = false;
    this._error = '';
  }
}
